module.exports = __webpack_public_path__ + "img/tintuc6.ba6534c7.png";